/** Only writable print fields: never send identity, __islocal, or children. */
export const buildOrderPrintUpdate = ({
    order, total, discountType, fixedDiscountAmount, selectedDiscount,
}) => {
    // Existing discounts are locked in the modal; preserve the actual amount,
    // not the rounded percentage used to display a selected discount button.
    const discount = Number(order.discount) > 0
        ? Number(order.discount)
        : discountType === "fixed" && fixedDiscountAmount > 0
        ? Math.min(total, fixedDiscountAmount)
        : total * (selectedDiscount || 0) / 100;
    return {
        discount,
        invoice_printed: 1,
    };
};
